import VueApexCharts from 'vue-apexcharts'

// "async" is optional
export default async ({ Vue }) => {
  Vue.component('apexchart', VueApexCharts)
}
